// extracted by mini-css-extract-plugin
export default {"login-container":"styles_login-container__WQ47z","login-wallpaper":"styles_login-wallpaper__KLqxj"};